// The Disposition & handoff tab's route and tab descriptor, apart from its registration so a reader needs no
// router and no window (the SSR suites load it alone).

import { CLOSURE_LABELS } from "./labels";

export interface ClosureRoute {
  rid: string;
  designate?: string | undefined;
}

/** `["R-1040", "closure?designate=app_1"]` → `{rid: "R-1040", designate: "app_1"}`; anything else → null. */
export function closureRoute(parts: readonly string[]): ClosureRoute | null {
  const rid = parts[0]?.split("?")[0] ?? "";
  const [tab, query = ""] = (parts[1] ?? "").split("?");
  if (!/^R-\d+$/.test(rid) || tab !== "closure") return null;
  const designate = new URLSearchParams(query).get("designate") ?? undefined;
  return { rid, designate: designate || undefined };
}

export const closureHref = (rid: string, designate?: string) =>
  `#requisitions/${rid}/closure${designate ? `?designate=${encodeURIComponent(designate)}` : ""}`;

/** The tab descriptor B2's requisition shell registers (T-12). */
export const CLOSURE_TAB = {
  key: "closure",
  label: CLOSURE_LABELS.tab,
  href: (rid: string) => closureHref(rid),
} as const;
